const $dateFields = $('[type="date"]');
// Most browsers that
const $unsupportedDatePickers = $dateFields.filter(function () {
	return this.type === 'text';
});

if ($unsupportedDatePickers.length) {
	import(/* webpackChunkName: "jquery-ui.datepicker" */ '../vendor/jquery-ui.datepicker').then(function () {
		$unsupportedDatePickers.each(function () {
			const $this = $(this);
			const options = {};

			if ($this.attr('min')) {
				options.minDate = new Date($this.attr('min'));
			}

			if ($this.attr('max')) {
				options.maxDate = new Date($this.attr('min'));
			}

			$(this).datepicker(options);
		});
	});
}